import {
    get,
    put,
    post,
    Delete,
    postWithQuery,
} from "../ApiDecorator";

/**
 * 空间管理 · 行前准备（/learn/spx/prePrepare）
 */
const PrePrepare = {
    /** GET 行前准备分页列表（管理端） */
    page(data) {
        return get("/learn/spx/prePrepare/page", data);
    },
    /** POST 新建行前准备，返回主键 id */
    create(data) {
        return post("/learn/spx/prePrepare", data);
    },
    /** PUT 更新行前准备主名称 */
    updatePrepareMeta(data) {
        return put("/learn/spx/prePrepare/prepare/meta", data);
    },
    /** GET 管理页详情（主名称、状态、区块与文件列表） */
    detail(data) {
        return get("/learn/spx/prePrepare/detail", data);
    },
    /** DELETE 逻辑删除行前准备 */
    deletePrepare(data) {
        return Delete("/learn/spx/prePrepare/prepare", data);
    },
    /** GET 发布弹窗：项目下结对空间及学生人数估算 */
    publishSpaces(data) {
        return get("/learn/spx/prePrepare/publishSpaces", data);
    },
    /** POST 发布到多个空间（全量替换发布关系） */
    publish(data) {
        return post("/learn/spx/prePrepare/publish", data);
    },
    /** POST 取消发布（参数在 query，与文档一致） */
    unpublish(data) {
        return postWithQuery("/learn/spx/prePrepare/unpublish", {}, {
            prepareId: data.prepareId,
            projectId: data.projectId,
        });
    },
    /** PUT 保存全部配置（主名称 + 区块与 fileIdentifiers 全量同步） */
    batchSave(data) {
        return put("/learn/spx/prePrepare/batchSave", data);
    },
    /** GET 学生端可见列表（已发布且含指定 spxId） */
    visible(data) {
        return get("/learn/spx/prePrepare/visible", data);
    },
    /** POST 新增内容区块，返回区块 id */
    createSection(data) {
        return post("/learn/spx/prePrepare/sections", data);
    },
    /** PUT 更新单个区块 */
    updateSection(data) {
        return put("/learn/spx/prePrepare/sections", data);
    },
    /** DELETE 删除区块及其文件关联 */
    deleteSection(data) {
        return Delete("/learn/spx/prePrepare/section", data);
    },
    /** POST 向区块追加绑定文件 identifier */
    bindSectionFiles(data) {
        return post("/learn/spx/prePrepare/sectionFiles", data);
    },
    /** DELETE 移除区块与单个文件的关联 */
    deleteSectionFile(data) {
        return Delete("/learn/spx/prePrepare/sectionFile", data);
    },
};

export default PrePrepare;
